export const WA_NUMBER = "6281381630445";
export const EMAIL = "natamatransasia63@gmail.com";
export const INSTAGRAM_URL = "https://www.instagram.com/natama_transasia";
export const INSTAGRAM_HANDLE = "@natama_transasia";
export const WA_DISPLAY = "+62 813-8163-0445";
export const EXTRA_PHONES = [
  { key: "admin2", number: "6281399698872", display: "+62 813-9969-8872", role: { id: "Admin 2", en: "Admin 2" } },
  { key: "cs", number: "6285697233196", display: "+62 856-9723-3196", role: { id: "Customer Service", en: "Customer Service" } },
];
export const ADDRESS = "Jl. Lingkar Utara No. 63, RT.010/RW.002, Teluk Pucung, Bekasi Utara, Kota Bekasi, Jawa Barat 17121";
export const MAPS_URL = "https://maps.app.goo.gl/KEoMD8bLhq881ypc6";

export const IMAGES = {
  hero: "/images/fleet-lineup.jpg",
  bigBus: "/images/bigbus-exterior.jpg",
  mediumBus: "/images/mediumbus-exterior.jpg",
  hiace: "/images/hiace-exterior.jpg",
  interior: "/images/interior-rear.jpg",
  office: "/images/office.jpg",
  fleetLineup: "/images/fleet-lineup.jpg",
  mediumInterior: "/images/mediumbus-interior.jpg",
  cockpit: "/images/mediumbus-cockpit.jpg",
  hiaceInterior: "/images/hiace-interior.jpg",
  interiorFront: "/images/interior-front.jpg",
  scenery: "https://images.unsplash.com/photo-1715704170926-0ca943fce5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxncmFuZCUyMG1vc3F1ZSUyMEluZG9uZXNpYSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3OTE4NjIyNzR8MA&ixlib=rb-4.1.0&q=85",
  corporate: "https://images.unsplash.com/photo-1602190276434-4cd5500bc6fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjB0cmF2ZWwlMjBncm91cHxlbnwwfHx8fDE3OTEzNTE1ODB8MA&ixlib=rb-4.1.0&q=85",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
